import React, { InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export const _RADIO_BUTTON_VARIANT = {
  DEFAULT: 'Default',
  SMALL: 'Small',
} as const;
export type RadioButtonVariant = keyof typeof _RADIO_BUTTON_VARIANT;

export const variantClasses: Record<RadioButtonVariant, string> = {
  DEFAULT: 'w-6 h-6',
  SMALL: 'w-4 h-4',
};

export interface RadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  variant: RadioButtonVariant;
  checked: boolean;
}

export const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ variant = 'DEFAULT', checked, className, ...rest }, ref) => {
    return (
      <input
        {...rest}
        ref={ref}
        checked={checked}
        type="radio"
        className={twMerge(
          'form-radio cursor-pointer checked:bg-[#240089]',
          checked ? 'border-opacity-100' : 'border-neutral-200',
          variantClasses[variant],
          className,
        )}
        value="1"
      />
    );
  },
);

RadioButton.displayName = 'RadioButton';
